import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom-v5-compat';
import { useSelector } from 'react-redux';
import Wrapper from '../layout/Wrapper';
import DateTime from '../components/DateTime';
import { usePostAppointmentMutation } from '../redux/api/vassApi';
import {
  selectSelectedTopics,
  selectSelectedSlot,
} from '../redux/slices/formSlice';
import { sortTopicsAlphabetically } from '../utils/appointments';
import { getBrowserTimezone } from '../utils/timezone';
import { URLS } from '../utils/constants';
import { pathWithSearch } from '../utils/invitationQuery';
import {
  isServerError,
  isAppointmentFailedError,
  isInvalidVeteranTimezoneError,
} from '../utils/errors';

const Review = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [postAppointment, { isLoading, error: postAppointmentError }] =
    usePostAppointmentMutation();
  const selectedTopics = useSelector(selectSelectedTopics);
  const selectedSlot = useSelector(selectSelectedSlot);
  const handleConfirmCall = async () => {
    const res = await postAppointment({
      topics: selectedTopics.map(topic => topic.topicId),
      dtStartUtc: selectedSlot.dtStartUtc,
      dtEndUtc: selectedSlot.dtEndUtc,
      veteranTimeZone: getBrowserTimezone(),
    });
    if (res.error) {
      return;
    }
    navigate(
      pathWithSearch(`${URLS.CONFIRMATION}/${res.data.appointmentId}`, search),
    );
  };

  return (
    <Wrapper
      pageTitle="Review your VA Solid Start call details"
      testID="review-page"
      showBackLink
      errorAlert={
        isServerError(postAppointmentError) ||
        isAppointmentFailedError(postAppointmentError) ||
        isInvalidVeteranTimezoneError(postAppointmentError)
      }
    >
      <div className="vads-u-display--flex vads-u-justify-content--space-between vads-u-align-items--center">
        <h2
          className="vads-u-font-size--h4 vads-u-margin--0"
          data-testid="date-time-title"
        >
          Date and time
        </h2>
        <Link
          to={URLS.DATE_TIME}
          data-testid="date-time-edit-link"
          aria-label="Edit date and time"
        >
          Edit
        </Link>
      </div>
      {selectedSlot.dtStartUtc && (
        <DateTime dateTime={selectedSlot.dtStartUtc} />
      )}
      <hr
        aria-hidden="true"
        className=" vads-u-margin-top--1 vads-u-margin-bottom--0p5"
      />
      <div className="vads-u-display--flex vads-u-justify-content--space-between vads-u-align-items--center">
        <h2
          className="vads-u-font-size--h4 vads-u-margin--0"
          data-testid="topic-title"
        >
          Topic
        </h2>
        <Link
          to={URLS.TOPIC_SELECTION}
          data-testid="topic-edit-link"
          aria-label="Edit topic"
        >
          Edit
        </Link>
      </div>
      <p
        className="vads-u-margin-top--0p5 vads-u-margin-bottom--1"
        data-dd-privacy="mask"
        data-testid="topic-description"
      >
        {sortTopicsAlphabetically(selectedTopics)
          .map(topic => topic?.topicName || '')
          .join(', ')}
      </p>
      <div className="vads-u-display--flex vads-u-margin-top--4 vass-form__button-container vass-flex-direction--column">
        <va-button
          big
          onClick={handleConfirmCall}
          loading={isLoading}
          text="Confirm call"
          data-testid="confirm-call-button"
          uswds
        />
      </div>
    </Wrapper>
  );
};

export default Review;
